// Footer Accordion JS Start
const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

  accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
  
  function toggleAccordion() {
    const items = document.querySelectorAll('.js-acc-item');
    const thisItem = this.parentNode;
  
    items.forEach(item => {
      if (thisItem == item) {
        thisItem.classList.toggle('is-open');
        return;
      }
      item.classList.remove('is-open');
    });
  }
// Footer Accordion JS End


// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {  
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });
}
function faq_toggle() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");  
      tabs_title.forEach(togal_tabs);
}
faq_toggle();
// faq tabs toggal end


// TAB JS CODE FOR FAQ

document.addEventListener("DOMContentLoaded", function () {

  const tabItems = document.querySelectorAll(".faq_tab_btn .tablinks");
  const panels = document.querySelectorAll(".panel");

  tabItems.forEach(tab => {
    tab.addEventListener("click", function () {

      const targetSelector = this.getAttribute("data-href");
      const targetPanel = document.querySelector(targetSelector);
      const anchor = this.querySelector("a");

      /* Remove active from all tabs & anchors */
      tabItems.forEach(item => {
        item.classList.remove("active");
        const a = item.querySelector("a");
        if (a) a.classList.remove("active");
      });

      /* Hide all panels */
      panels.forEach(panel => {
        panel.classList.add("hidden");
        panel.classList.remove("active");
      });

      /* Activate clicked tab */
      this.classList.add("active");
      if (anchor) anchor.classList.add("active");

      /* Show matching panel */
      if (targetPanel) {
        targetPanel.classList.remove("hidden");
        targetPanel.classList.add("active");
      }
    });
  });

});


  const section = document.querySelector(".product_tab");
if(section){

  const tabs = section.querySelectorAll(".tab-item");
  console.log(tabs,"tabs")
  const contents = section.querySelectorAll(".tab-content");

  
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      const targetId = this.dataset.id;
      if (!targetId) return;

      // Remove active
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Add active
      this.classList.add("active");

      const targetContent = section.querySelector("#" + targetId);
      if (targetContent) {
        targetContent.classList.add("active");
      }

    });
  });
}


// const links = document.querySelectorAll('a.more_text');

// if (links.length > 0) {
//   links.forEach(link => {
//     link.addEventListener('click', function(e) {
//       e.preventDefault();

//       // Always open first tab-content
//       const firstTab = document.querySelector('.tab-content');
//       const firstTabtitle = document.querySelector('.tab-item');

//       if (!firstTab) return;

//       // Remove active from all tabs
//       document.querySelectorAll('.tab-content').forEach(tab => {
//         tab.classList.remove('active');
//       });
//          // Remove active from all tabs
//       document.querySelectorAll('.tab-item').forEach(tab => {
//         tab.classList.remove('active');
//       });

//       // Add active only to first tab
//       firstTab.classList.add('active');
//       firstTabtitle.classList.add('active')

//       // Smooth scroll to first tab
//       setTimeout(() => {
//         const offset = 100; // sticky header offset
//         const topPosition =
//           firstTab.getBoundingClientRect().top + window.pageYOffset - offset;

//         window.scrollTo({
//           top: topPosition,
//           behavior: 'smooth'
//         });
//       }, 100);
//     });
//   });
// }



const links = document.querySelectorAll('a.more_text');

if (links.length > 0) { 
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);
      if (!target) return;
      const matchingTab = document.querySelector('.tab-item_sec');
      document.querySelectorAll('li.tab-item').forEach(li => {
        li.classList.remove('active');
      });

      if (matchingTab) {
        matchingTab.classList.add('active');
      }

      const tabContent = target.closest('.tab-content');
      if (tabContent && !tabContent.classList.contains('active')) {
        tabContent.classList.add('active');

        tabContent.parentElement.querySelectorAll('.tab-content').forEach(tc => {
          if (tc !== tabContent) tc.classList.remove('active');
        });
      }

      // setTimeout(() => {
      //   const offset = 100; // adjust for sticky header
      //   const bodyRect = document.body.getBoundingClientRect().top;
      //   const elementRect = target.getBoundingClientRect().top;
      //   const elementPosition = elementRect - bodyRect;

      //   window.scrollTo({
      //     top: elementPosition,
      //     behavior: 'smooth'
      //   });
      // }, 100);


      setTimeout(() => {
  const offset = 100;

  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = target.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;

  window.scrollTo({
    top: elementPosition - offset,
    behavior: 'smooth'
  });
}, 100);

    });
  });
}


const shortDesc = document.querySelector('.shor_desc_wapper') || null;

 if(shortDesc){
  shortDesc.addEventListener('click', function () {
    this.classList.toggle('active');
  });
}



document.addEventListener("click", function (e) {
  const link = e.target.closest(".tmp-page-event .custom_link");

  if (!link) return;

  e.preventDefault();

  // href mathi target id lo
  const targetId = link.getAttribute("href");

  if (!targetId) return;

  // target section
  const targetSection = document.querySelector(targetId);

  if (targetSection) {
    targetSection.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
});